import * as jquery from 'jquery'
import { getjQuery } from './util/index'
const $ = getjQuery() || jquery

export default {
  $
}
